import type {TypedLocale} from 'payload'

type Lang = TypedLocale | string

export const dict = {
	fr: {
		discover_website: 'Découvrir le site',
		awards_title:     'Récompenses',
		team_title:       'Équipe',
		team_meta_title:  'Équipe - Ziben',
		team_description: 'Membres de l\'équipe Ziben',
	},
	en: {
		discover_website: 'Discover website',
		awards_title:     'Awards',
		team_title:       'Team',
		team_meta_title:  'Team - Ziben',
		team_description: 'Members of the Ziben team',
	},
} as const

export type DictKey = keyof typeof dict.fr
export type AllowedLocale = keyof typeof dict

export const ALLOWED_LOCALES = Object.keys(dict) as AllowedLocale[]

export const isAllowedLocale = (lang: string): lang is AllowedLocale =>
	(ALLOWED_LOCALES as string[]).includes(lang)

export const t = (lang: Lang, key: DictKey): string => {
	if (isAllowedLocale(lang)) return dict[lang][key]
	if (process.env.NODE_ENV !== 'production') {
		console.warn(`[i18n] unknown locale "${lang}", falling back to "en" for key "${key}"`)
	}
	return dict.en[key] ?? key
}
